module.exports = __webpack_public_path__ + "img/aaqilah-isaacs.afa8fcdc.png";